const validId = (id) => Number.isSafeInteger(id) && id > 0

const flag = (user, name) => {
  const value = user?.[name]
  if (value === true || value === 1 || value === 'true') return true
  if (value === false || value === 0 || value === 'false') return false
  return null
}

// Use raw response flags: the Web API parser defaults missing booleans to false.
export const classifyActor = (user, rawUser) => {
  if (!validId(user?.id) || !validId(user?.accountId)) return 'unknown'

  const automation = flag(rawUser, 'isAutomatedSurveyUser')
  const shared = flag(rawUser, 'isResidentEngagementUser')
  const demo = flag(rawUser, 'isDemoUser')
  const internal = flag(rawUser, 'isInternal')

  if (automation === true) return 'automation'
  if (automation !== false) return 'unknown'
  if (shared === true) return 'shared_operator'
  if (shared !== false) return 'unknown'
  if (demo === true) return 'demo'
  if (demo !== false) return 'unknown'
  if (internal === true) return 'internal_staff'
  return internal === false ? 'client_account' : 'unknown'
}
